import VerifyPhoneNumber from 'features/myVaro/screens/PersonalDetails/ChangeEmail/VerifyPhoneNumber/VerifyPhoneNumber';
import React from 'react';

export default function EnterCodePage() {
  return <VerifyPhoneNumber />;
}
